module.exports = __webpack_public_path__ + "src/assets/img/net_lost.af82a178.svg";